
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m18.363 18.364c0.3905-0.3905 0.3905-1.0237 0-1.4142-0.3905-0.3906-1.0237-0.3906-1.4142 0l1.4142 1.4142zm-0.7071-12.021-0.7071 0.7071 0.0146 0.01463 0.0152 0.01402 0.6773-0.73575zm1.6659 2.8926c0.4063 0.37404 1.0389 0.34785 1.413-0.05849 0.374-0.40635 0.3478-1.039-0.0585-1.413l-1.3545 1.4715zm-2.373 7.714c-2.7337 2.7336-7.1658 2.7336-9.8995 0l-1.4142 1.4142c3.5147 3.5147 9.2132 3.5147 12.728 0l-1.4142-1.4142zm-9.8995 0c-2.7337-2.7337-2.7337-7.1659 0-9.8995l-1.4142-1.4142c-3.5147 3.5147-3.5147 9.2132 0 12.728l1.4142-1.4142zm0-9.8995c2.7337-2.7337 7.1658-2.7337 9.8995 0l1.4142-1.4142c-3.5147-3.5147-9.2132-3.5147-12.728 0l1.4142 1.4142zm9.9293 0.02865 2.3432 2.1568 1.3545-1.4715-2.3432-2.1568-1.3545 1.4715z","fill":"currentColor"}}),_c('path',{attrs:{"d":"m12 8v4l3.5 2","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"m19.999 4.5v4h-4","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    